/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isuserallowedtoaccessspeakersettings6Inputs */

const en_entity_isuserallowedtoaccessspeakersettings6 = /** @type {(inputs: Entity_Isuserallowedtoaccessspeakersettings6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Allowed To Access Speaker Settings`)
};

const de_entity_isuserallowedtoaccessspeakersettings6 = /** @type {(inputs: Entity_Isuserallowedtoaccessspeakersettings6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer darf Lautsprechereinstellungen öffnen`)
};

/**
* | output |
* | --- |
* | "Is User Allowed To Access Speaker Settings" |
*
* @param {Entity_Isuserallowedtoaccessspeakersettings6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isuserallowedtoaccessspeakersettings6 = /** @type {((inputs?: Entity_Isuserallowedtoaccessspeakersettings6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isuserallowedtoaccessspeakersettings6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isuserallowedtoaccessspeakersettings6(inputs)
	return de_entity_isuserallowedtoaccessspeakersettings6(inputs)
});
export { entity_isuserallowedtoaccessspeakersettings6 as "entity_isUserAllowedToAccessSpeakerSettings" }